import { baseNumberFormatter, moneyFormatter } from 'utils/number';
import { sortBy } from 'lodash';

export const GROUP_BY_FILTER_TYPES = {
  CREATED_DATE: 'createdDate',
  CREATED_HOUR: 'createdDateHourly',
  PUBLISHER: 'publisher',
  ENDPOINT: 'uPublisherId',
  WLID: 'wlid',
  GEO: 'geo',
};

export const BASE_CHART_LINE_COLORS = [
  '#3098a3',
  '#6aaaf3',
  '#f3906a',
  '#37b67d',
  '#ddac45',
  '#2954ff',
  '#FEB019',
];

export const REPORT_CHART_METRICS_TYPE = {
  IMPRESSIONS: 'impressions',
  CLICKS: 'clicks',
  SPEND: 'spend',
  VISITS: 'visits',
  LOGINS: 'logins',
  REG_STARTED: 'regsStarted',
  REG_FINISHED: 'regsFinished',
  FTDS: 'ftds',
  FTD_AMOUNT_DOLLARS: 'ftdsAmount',
  DEPOSITS: 'deposits',
  DEPOSIT_AMOUNT_DOLLARS: 'depositsAmount',
  WITHDRAWAL: 'withdrawals',
  BET: 'bets',
  OTHER: 'others',
};

export const REPORT_CHART_METRICS_TYPE_OPTIONS = [
  {
    label: 'Impressions',
    value: REPORT_CHART_METRICS_TYPE.IMPRESSIONS,
  },
  {
    label: 'Clicks',
    value: REPORT_CHART_METRICS_TYPE.CLICKS,
  },
  {
    label: 'Spend',
    value: REPORT_CHART_METRICS_TYPE.SPEND,
  },
  {
    label: 'Visits',
    value: REPORT_CHART_METRICS_TYPE.VISITS,
  },
  {
    label: 'Logins',
    value: REPORT_CHART_METRICS_TYPE.LOGINS,
  },
  {
    label: 'Reg Started',
    value: REPORT_CHART_METRICS_TYPE.REG_STARTED,
  },
  {
    label: 'Reg Finished',
    value: REPORT_CHART_METRICS_TYPE.REG_FINISHED,
  },
  {
    label: 'FTDs',
    value: REPORT_CHART_METRICS_TYPE.FTDS,
  },
  {
    label: 'FTD Amount ($)',
    value: REPORT_CHART_METRICS_TYPE.FTD_AMOUNT_DOLLARS,
  },
  {
    label: 'Deposits',
    value: REPORT_CHART_METRICS_TYPE.DEPOSITS,
  },
  {
    label: 'Deposit Amount ($)',
    value: REPORT_CHART_METRICS_TYPE.DEPOSIT_AMOUNT_DOLLARS,
  },
  {
    label: 'Withdrawal',
    value: REPORT_CHART_METRICS_TYPE.WITHDRAWAL,
  },
  {
    label: 'Bet',
    value: REPORT_CHART_METRICS_TYPE.BET,
  },
  {
    label: 'Other',
    value: REPORT_CHART_METRICS_TYPE.OTHER,
  },
];

export const REPORT_CHART_FORMATTERS_BY_METRICS_TYPE = {
  [REPORT_CHART_METRICS_TYPE.IMPRESSIONS]: baseNumberFormatter,
  [REPORT_CHART_METRICS_TYPE.CLICKS]: baseNumberFormatter,
  [REPORT_CHART_METRICS_TYPE.SPEND]: moneyFormatter,
  [REPORT_CHART_METRICS_TYPE.VISITS]: baseNumberFormatter,
  [REPORT_CHART_METRICS_TYPE.LOGINS]: baseNumberFormatter,
  [REPORT_CHART_METRICS_TYPE.REG_STARTED]: baseNumberFormatter,
  [REPORT_CHART_METRICS_TYPE.REG_FINISHED]: baseNumberFormatter,
  [REPORT_CHART_METRICS_TYPE.FTDS]: baseNumberFormatter,
  [REPORT_CHART_METRICS_TYPE.FTD_AMOUNT_DOLLARS]: moneyFormatter,
  [REPORT_CHART_METRICS_TYPE.DEPOSITS]: baseNumberFormatter,
  [REPORT_CHART_METRICS_TYPE.DEPOSIT_AMOUNT_DOLLARS]: moneyFormatter,
  [REPORT_CHART_METRICS_TYPE.WITHDRAWAL]: baseNumberFormatter,
  [REPORT_CHART_METRICS_TYPE.BET]: baseNumberFormatter,
  [REPORT_CHART_METRICS_TYPE.OTHER]: baseNumberFormatter,
};

const extractNumber = (item) => {
  const raw = item.name;

  const match = String(raw).match(/^\(?(\d+)\)?/);
  console.log('EX_N', { item, match });
  return match ? parseInt(match[1], 10) : -Infinity;
};

export const REPORT_CHART_TOOLTIPS_PAYLOAD_SORTING_MODEL = {
  [GROUP_BY_FILTER_TYPES.CREATED_DATE]: (payload) => payload,
  [GROUP_BY_FILTER_TYPES.PUBLISHER]: (payload) =>
    sortBy(payload, extractNumber).reverse(),
  [GROUP_BY_FILTER_TYPES.ENDPOINT]: (payload) => {
    console.log('SORT');
    return sortBy(payload, extractNumber).reverse();
  },
  [GROUP_BY_FILTER_TYPES.WLID]: (payload) =>
    sortBy(payload, extractNumber).reverse(),
  [GROUP_BY_FILTER_TYPES.GEO]: (payload) =>
    sortBy(payload, ['value']).reverse(),
  [GROUP_BY_FILTER_TYPES.CREATED_HOUR]: (payload) => payload,
};

export const DEFAULT_GROUP_BY_TYPE = GROUP_BY_FILTER_TYPES.CREATED_DATE;

export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';
export const DEFAULT_DATETIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';
export const REPORT_DATE_FORMAT = DEFAULT_DATE_FORMAT;
export const REPORT_DATETIME_FORMAT = DEFAULT_DATETIME_FORMAT;

export const AD_TYPES_LABELS = {
  BANNER: 'Banner',
  NATIVE: 'Native',
  VIDEO: 'Video',
  POP: 'Pop',
  PUSH: 'Push',
};
export const ATTRIBUTION_TYPES_LABELS = {
  click: 'Post Click',
  imp: 'Post View',
  notAttr: 'Not Attributed',
};
export const GROUP_BY_TYPES_LABELS = {
  [GROUP_BY_FILTER_TYPES.CREATED_DATE]: 'Date',
  [GROUP_BY_FILTER_TYPES.CREATED_HOUR]: 'Date & Hour',
  [GROUP_BY_FILTER_TYPES.PUBLISHER]: 'Publisher',
  [GROUP_BY_FILTER_TYPES.ENDPOINT]: 'Endpoint',
  [GROUP_BY_FILTER_TYPES.WLID]: 'Client',
  [GROUP_BY_FILTER_TYPES.GEO]: 'Geo',
};

export const PUBLISHER_TYPE_LABELS = {
  GATEWAY: 'Gateway',
  MANUAL: 'Manual',
};
